import React from "react";
import { Dropdown } from "antd";
import { BgColorsOutlined, CheckOutlined } from "@ant-design/icons";
import { DEFAULT_THEME, THEME_ORDER, themeLabels, themePreviewHex } from "./theme";
import useThemeSwitcher from "./useThemeSwitcher";
import "./ThemeSwitcher.css";

const ThemeSwitcher: React.FC = () => {
  const { currentTheme, setTheme } = useThemeSwitcher();
  const [open, setOpen] = React.useState(false);
  const currentLabel = themeLabels[currentTheme] ?? themeLabels[DEFAULT_THEME];
  const previewHex = themePreviewHex[currentTheme] ?? themePreviewHex[DEFAULT_THEME];

  const overlay = (
    <div className="theme-picker-overlay" role="group" aria-label="Chọn chủ đề màu">
      <div className="theme-picker-grid">
        {THEME_ORDER.map((id) => {
          const active = currentTheme === id;
          return (
            <button
              key={id}
              type="button"
              aria-pressed={active}
              aria-label={themeLabels[id]}
              className={`theme-picker-cell${active ? " theme-picker-cell--active" : ""}`}
              onClick={() => {
                setTheme(id);
                setOpen(false);
              }}
            >
              {active ? (
                <CheckOutlined className="theme-picker-check" aria-hidden />
              ) : null}
              <span
                className="theme-picker-swatch"
                style={{ backgroundColor: themePreviewHex[id] }}
                aria-hidden
              />
              <span className="theme-picker-label">{themeLabels[id]}</span>
            </button>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className="theme-switcher-container">
      <Dropdown
        overlay={overlay}
        trigger={["click"]}
        placement="bottomRight"
        visible={open}
        onVisibleChange={setOpen}
      >
        <div
          className="theme-switcher-button theme-switcher-button--picker"
          tabIndex={0}
          role="button"
          aria-expanded={open}
          aria-haspopup="true"
        >
          <div className="theme-switcher-content">
            <BgColorsOutlined style={{ marginRight: 8 }} />
            <span style={{ flex: 1 }}>{currentLabel}</span>
            <span
              className="theme-switcher-chip"
              style={{ backgroundColor: previewHex }}
              aria-hidden
            />
          </div>
        </div>
      </Dropdown>
    </div>
  );
};

export default ThemeSwitcher;
